import React__default from 'react';

const Button = ({
  label,
  onClick,
  variant = 'primary',
  size = 'medium',
  rounded,
  inverted,
  className,
  disabled,
  isLoading,
  ...props
}) => {
  const getClassNames = () => {
    let classNames = ['move-btn'];
    if (variant) classNames.push(`move-btn--${variant}`);
    if (size) classNames.push(`move-btn--${size}`);
    if (rounded) classNames.push('rounded');
    if (inverted) classNames.push('inverted');
    if (className) classNames.push(className);
    return classNames.join(' ');
  };
  return /*#__PURE__*/React__default.createElement("button", {
    ...props,
    className: getClassNames(),
    onClick: onClick,
    disabled: disabled || isLoading
  }, isLoading && /*#__PURE__*/React__default.createElement("i", {
    className: "ri-loader-4-line animate-spin me-2 inline-flex"
  }), label);
};

export { Button as default };
//# sourceMappingURL=Button.esm.js.map
